import "katex/dist/katex.min.css";

import { Head, Layout, Post, PostCategory, PostTags } from "@components";

import { DiscussionEmbed } from "disqus-react";
import React from "react";
import { graphql } from "gatsby";
import styles from "@styles/PostLayout.module.scss";

type Props = {
	pageContext: {
		categories: { category: string, count: number, href: string }[];
		tags: { tag: string, count: number, href: string }[];
	},
	data: {
		markdownRemark: {
			html: string
			frontmatter: {
				date: string
				slug: string
				title: string
				category: string
				tags: string[]
				description: string
			}
		}
	}
}

const PostLayout: React.FC<Props> = ({ data, pageContext }) => {
	const {
		html,
		frontmatter: {
			date, title, category, tags, slug, description,
		}
	} = data.markdownRemark;
	const disqusConfig = {
		shortname: "jebae-github-io",
		config: { identifier: slug, title },
	};

	return (
		<Layout categories={ pageContext.categories } tags={ pageContext.tags }>
			<Head
				title={ title }
				description={ description }
				keywords={ [category, ...tags] }
			/>
			<h1 className={ styles.title }>{ title }</h1>
			<h3 className={ styles.description }>{ description }</h3>
			<h3 className={ styles.createdAt }>{ date }</h3>
			<Post>
				<div dangerouslySetInnerHTML={ { __html: html } }/>
			</Post>
			<section className={ styles.postFilters }>
				<PostCategory category={ category } href={ `/category/${category}` }/>
				<PostTags tags={ tags.map(tag => ({ tag, href: `/tag/${tag}` })) }/>
			</section>
			<section className={ styles.comments }>
				<DiscussionEmbed { ...disqusConfig }/>
			</section>
		</Layout>
	);
};

export const pageQuery = graphql`
	query ($slug: String!) {
		markdownRemark(frontmatter: { slug: { eq: $slug } }) {
			html
			frontmatter {
				date(formatString: "YYYY년 MM월 DD일")
				slug
				title
				tags
				category
				description
			}
		}
	}
`;

export default PostLayout;
